import { Navigate, Route, Routes } from "react-router-dom";
import { useQuery } from "react-query";
import values from "../panel/values";
import api from "../panel/api";
import Cookies from "js-cookie";
import Context from "../panel/context";
import utils from "../panel/utils";
import WebsiteNavigation from "../website/routes";
import PanelNavigation from "../panel/routes";

const Navigation = () => {
  return (
    <Routes>
      <Route path="/" element={<WebsiteNavigation />} />
      <Route path="/panel/*" element={<PanelNavigation />} />
    </Routes>
  );
};

export default Navigation;
